export default "/_next/static/images/product-surveys-5ad3d82c5bef24e048bde4ed42075bf0.svg";